import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './LanguageSwitcher.css';

const languages = [
  { code: 'en', label: 'EN' },
  { code: 'ro', label: 'RO' },
];

export default function LanguageSwitcher({ variant }) {
  const { lang, switchLang } = useLanguage();

  return (
    <div className={`lang-switcher ${variant === 'surface' ? 'lang-switcher--surface' : ''}`}>
      {languages.map((l) => (
        <button
          key={l.code}
          className={`lang-btn ${lang === l.code ? 'active' : ''}`}
          onClick={() => switchLang(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
